import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { useImageGeneration } from '.';

export default function GenderSelector() {
  const { gender, setGender } = useImageGeneration();

  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'neutral', label: 'Neutral' },
  ] as const;

  return (
    <div className='px-4 space-y-2'>
      <Label className='text-base font-semibold text-neutral-50 leading-tight'>
        Gender
      </Label>
      <RadioGroup
        value={gender}
        onValueChange={(value) =>
          setGender(value as 'male' | 'female' | 'neutral' | '')
        }
        className='flex space-x-4'
      >
        {genderOptions.map((option) => (
          <div key={option.value} className='flex items-center space-x-2'>
            <RadioGroupItem
              value={option.value}
              id={option.value}
              className='text-fuchsia-600 border-fuchsia-600 data-[state=checked]:bg-fuchsia-600'
            />
            <Label
              htmlFor={option.value}
              className='text-stone-50/90 text-sm cursor-pointer'
            >
              {option.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
      <Label className='text-xs text-stone-50/60'>
        Select the gender for your image generation.
      </Label>
    </div>
  );
}
